import React, { useState, useEffect } from "react";
import { Card, Button, Input, Select, Pagination, Badge } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./payment.css";

const { Option } = Select;

const PaymentHistoryPage = () => {
  const [payments, setPayments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("all");
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4; // Number of items per page

  const samplePayments = [
    {
      id: 1,
      studentName: "John Doe",
      status: "Processing",
      amount: 1000,
      date: "19/12/2023",
      description: "Tuition Fee",
    },
    {
      id: 2,
      studentName: "Jane Smith",
      status: "Success",
      amount: 750,
      date: "15/12/2023",
      description: "Book Purchase",
    },
    {
      id: 3,
      studentName: "Jane Smith",
      status: "Cancelled",
      amount: 1750,
      date: "15/12/2023",
      description: "Speech Therapy",
    },
    {
      id: 4,
      studentName: "Jake Smith",
      status: "Cancelled",
      amount: 1750,
      date: "15/12/2023",
      description: "Speech Therapy",
    },
    {
      id: 5,
      studentName: "John Done",
      status: "Success",
      amount: 1750,
      date: "15/01/2024",
      description: "Speech Therapy",
    },
    {
      id: 6,
      studentName: "David",
      status: "Success",
      amount: 1750,
      date: "15/01/2024",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt",
    },
  ];

  useEffect(() => {
    setPayments(samplePayments);
    setCurrentDateTime(getCurrentDateTime());
  }, []);

  const handleFilterChange = (value) => {
    setFilter(value);
    setCurrentPage(1);
  };

  const filteredPayments = payments.filter((payment) => {
    if (filter === "all") {
      return true;
    }
    return payment.status.toLowerCase() === filter.toLowerCase();
  });

  const indexOfLastPayment = currentPage * pageSize;
  const indexOfFirstPayment = indexOfLastPayment - pageSize;
  const currentPayments = filteredPayments.slice(
    indexOfFirstPayment,
    indexOfLastPayment
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const optionsDate = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const optionsTime = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = now.toLocaleString("en-US", optionsDate);
    const formattedTime = now.toLocaleString("en-US", optionsTime);

    return (
      <div>
        {formattedDate}
        <br />
        {formattedTime}
      </div>
    );
  };
  const MAX_DESCRIPTION_LINES = 3;
  return (
    <div className="page-wrapper">
    <div className="bg-content">
      <div
        className="payment-history-header d-flex justify-content-between align-items-start"
      >
        <div className="title-payment h2 fw-bold">Payment History</div>
        <div className="current-date-time">{getCurrentDateTime()}</div>
      </div>
      <div className="input-boxes">
        <div className="search-box">
          <Input
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e.target.value)}
            suffix={<SearchOutlined />}
          />
        </div>
        <div className="filter-box">
          <Select
            defaultValue="all"
            style={{ width: "100%" }}
            onChange={handleFilterChange}
          >
            <Option value="all">Filter By</Option>
            <Option value="Processing">Processing</Option>
            <Option value="Success">Success</Option>
            <Option value="Cancelled">Cancelled</Option>
          </Select>
        </div>
      </div>
      <div className="payment-card-container">
        {currentPayments.map((payment) => (
          <Card className="info-card" key={payment.id}>
            <div className="info-row">
              <div className="Status">
                <span className="label">Status</span>
                <div  className="badge-values">
                  <Badge
                    color={
                      payment.status === "Success"
                        ? "green"
                        : payment.status === "Processing"
                        ? "#fadb14"
                        : "red"
                    }
                    style={{padding:"0 8px 0 8px"}}
                  />
                  <span>{payment.status}</span>
                </div>
              </div>
              <div className="Amount">
                <span className="label">Amount</span>
                <span className="values">{payment.amount}</span>
              </div>
              <div className="Date">
                <span className="label">Date</span>
                <span className="values">{payment.date}</span>
              </div>
              <div className="Description">
                <span className="label">Description</span>
                <div
                className="values"
                style={{
                  maxHeight: `${MAX_DESCRIPTION_LINES * 1.2}em`, // Adjust line height as needed
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {payment.description}
              </div>
              </div>
              <div className="Details">
                <Button type="primary" href={`paymentdetails/${payment.id}`}>
                  Details
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={filteredPayments.length}
          onChange={paginate}
        />
      </div>
    </div>
    </div>
  );
};

export default PaymentHistoryPage;
